const alertSubtleLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5"/><path stroke-width="0" d="M11.25 15.5h1.5V17h-1.5zm0-8.75h1.5v7h-1.5z"/></svg>',
};

export { alertSubtleLarge as default };
